module.exports = __webpack_public_path__ + "static/media/edit-brief-icon.f6730a6d.svg";